import { useSelector, useDispatch } from 'react-redux';
import { resolveObjectFit } from '../../../../utils/imageFit';

import { Media } from '../../ShowMedia/Media';
import { LazyLoadImage } from 'react-lazy-load-image-component';


function CornerMediaPreview({ imageFit, maintainAspectRatio, item, area, setArea, settings = false }) {

    const handleMouseDown = (event) => {
        event.preventDefault();
        const startX = event.clientX;
        const startY = event.clientY;

        const scaledWidth = 500;
        const scaledHeight = 375;
        const div = document.getElementById(`resizable`);
        if (!div) return;

        const rect = div.getBoundingClientRect();
        const edgeThreshold = 10;

        const nearLeft = startX - rect.left < edgeThreshold;
        const nearRight = rect.right - startX < edgeThreshold;
        const nearTop = startY - rect.top < edgeThreshold;
        const nearBottom = rect.bottom - startY < edgeThreshold;

        // Determine action
        let action = 'move';
        if (nearLeft) action = 'resizeLeft';
        if (nearRight) action = 'resizeRight';
        if (nearTop) action = 'resizeTop';
        if (nearBottom) action = 'resizeBottom';

        const handleMouseMove = (moveEvent) => {
            let dx = moveEvent.clientX - startX;
            let dy = moveEvent.clientY - startY;

            let newX = area.start_margin;
            let newY = area.top_margin;
            let newWidth = area.width;
            let newHeight = area.height;

            const speedFactor = 2;

            if (action === 'resizeRight') {
                newWidth = Math.min(100 - area.start_margin, area.width + (dx / scaledWidth) * 100);
            } else if (action === 'resizeLeft') {
                let tempX = area.start_margin + (dx / scaledWidth) * 100;
                let tempWidth = area.width - (dx / scaledWidth) * 100;

                if (tempX < 0) {
                    tempWidth = area.width + area.start_margin;
                    tempX = 0;
                }
                if (tempWidth >= 5) {
                    newX = tempX;
                    newWidth = Math.min(100 - tempX, tempWidth);
                }
            } else if (action === 'resizeBottom') {
                newHeight = Math.min(100 - area.top_margin, area.height + (dy / scaledHeight) * 100);
            } else if (action === 'resizeTop') {
                let tempY = area.top_margin + (dy / scaledHeight) * 100;
                let tempHeight = area.height - (dy / scaledHeight) * 100;
                if (tempY < 0) {
                    tempHeight = area.height + area.top_margin;
                    tempY = 0;
                }
                if (tempHeight >= 5) {
                    newY = tempY;
                    newHeight = Math.min(100 - tempY, tempHeight);
                }
            } else if (action === 'move') {
                newX = Math.max(0, Math.min(100 - area.width, area.start_margin + (dx / scaledWidth) * 100));
                newY = Math.max(0, Math.min(100 - area.height, area.top_margin + (dy / scaledHeight) * 100));
            }

            setArea({ start_margin: newX, top_margin: newY, width: newWidth, height: newHeight })
        }
        const handleMouseUp = () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);


    };

    return (
        <>
            <div className='w-100  px-3 flex justify-center items-center'
                style={{
                    minHeight: settings ? "" : "600px",
                    //   width: "854px"
                }}  >
                <div className=' media-container-settings overflow-hidden border-3  bg-gray-50 relative object-cover  w-100 ' style={{
                    // maxHeight: "500px",
                    height: "480px",
                    //  width: "854px"
                }}
                >
                    < div
                        id={`resizable`}
                        key={`resizable `}
                        onMouseDown={(e) => handleMouseDown(e)}
                        className='border-2 overflow-hidden border-gray-400 border-dashed absolute cursor-pointer resizable media-preview-corner'
                        style={{
                            left: `${area?.start_margin ? area?.start_margin : 0}%`,
                            top: `${area.top_margin ? area?.top_margin : 0}%`,
                            width: `${area.width ? area?.width : 100}%`,
                            height: `${area.height ? area?.height : 100}%`,
                        }}
                    >
                        {item.playlist_media_id ?

                            <div className='   w-100 h-100 me-2 p-4 rounded-2 bg-secondary d-flex align-items-center justify-content-center'>
                                <i className="fas fa-list-ul fs-4  text-white"></i>
                            </div>
                            :

                            <LazyLoadImage src={item.type === "VIDEO" ? item.thumb : item.path} style={{
                                width: '100%',
                                height: '100%',
                                objectFit: resolveObjectFit(imageFit, maintainAspectRatio),
                            }} />
                        }

                        <> <div className="resize-handle bg-black" style={{ top: "50%", left: -5, cursor: "ew-resize" }} onMouseDown={(e) => handleMouseDown(e)}></div>
                            <div className="resize-handle bg-black" style={{ top: -5, right: "50%", cursor: "ns-resize" }} onMouseDown={(e) => handleMouseDown(e)} ></div>
                            <div className="resize-handle bg-black" style={{ bottom: -5, right: "50%", cursor: "ns-resize" }} onMouseDown={(e) => handleMouseDown(e)} ></div>
                            <div className="resize-handle bg-black" style={{ top: "50%", right: -5, cursor: "ew-resize" }} onMouseDown={(e) => handleMouseDown(e)}></div>
                        </>
                    </div>

                </div>
            </div>


        </>
    )
}

export default CornerMediaPreview